window.Shopify = window.Shopify || {};
window.Shopify.routes = window.Shopify.routes || { root: '/' };
window.Shopify.routes.root = window.Shopify.routes.root || '/';

function updateCartCount(count) {
  document.querySelectorAll('[data-cart-count]').forEach(function (badge) {
    badge.textContent = count;
    badge.classList.toggle('is-hidden', count === 0);
  });
}

function formatMoney(cents) {
  return new Intl.NumberFormat('sv-SE', {
    style: 'currency',
    currency: window.Shopify.currency.active,
    minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
    maximumFractionDigits: cents % 100 === 0 ? 0 : 2
  }).format(cents / 100);
}

function showCartAddedDialog(item) {
  var dialog = document.querySelector('[data-cart-added-dialog]');
  if (!dialog) return;
  var image = dialog.querySelector('[data-cart-added-image]');
  var imageUrl = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
  image.src = imageUrl || '';
  image.alt = item.product_title || item.title || '';
  image.parentElement.classList.toggle('is-empty', !imageUrl);
  dialog.querySelector('[data-cart-added-title]').textContent = item.product_title || item.title || '';
  var priceEl = dialog.querySelector('[data-cart-added-price]');
  priceEl.textContent = formatMoney(item.final_price || item.price || 0);
  var wasPrice = item.compare_at_price || item.original_price || 0;
  priceEl.classList.toggle('is-sale', parseFloat(wasPrice) > parseFloat(item.final_price || item.price || 0));

  dialog.querySelector('[data-cart-added-quantity]').textContent = 'Antal: ' + item.quantity;
  dialog.showModal();
}

document.addEventListener('click', function (event) {
  var burger = event.target.closest('[data-menu-toggle]');
  if (burger) {
    var nav = document.getElementById('mobile-nav');
    if (nav) {
      var isOpen = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', String(isOpen));
    }
  }

  var categoriesLink = event.target.closest('[data-scroll-categories]');
  if (categoriesLink) {
    var categories = document.getElementById('kategorier');
    if (categories) {
      event.preventDefault();
      categories.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var openNav = document.getElementById('mobile-nav');
      if (openNav) openNav.classList.remove('is-open');
      var menuButton = document.querySelector('[data-menu-toggle]');
      if (menuButton) menuButton.setAttribute('aria-expanded', 'false');
    }
  }

  var thumb = event.target.closest('[data-thumb]');
  if (thumb) {
    var gallery = thumb.closest('[data-product-gallery]');
    var main = gallery && gallery.querySelector('#product-main-image');
    var counter = gallery && gallery.querySelector('[data-image-counter]');
    if (main) {
      main.src = thumb.getAttribute('data-full');
      main.setAttribute('data-full', thumb.getAttribute('data-full'));
      main.removeAttribute('srcset');
      gallery.querySelectorAll('[data-thumb]').forEach(function (item) { item.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (counter) counter.textContent = (Number(thumb.getAttribute('data-index')) + 1) + '/' + gallery.querySelectorAll('[data-thumb]').length;
    }
  }

  var catalogFilter = event.target.closest('[data-catalog-filter]');
  if (catalogFilter) {
    var carousel = document.querySelector('[data-product-carousel]');
    if (carousel) {
      carousel.dataset.catalogFilter = catalogFilter.getAttribute('data-catalog-filter') || 'alla';
      carousel.dataset.productPage = '0';
      updateProductCarousel(carousel);
    }
    var products = document.getElementById('products');
    if (products) products.scrollIntoView({ behavior: 'smooth' });
  }

  var productView = event.target.closest('[data-product-view]');
  if (productView) {
    var productTabs = productView.closest('[data-product-tabs]');
    productTabs.querySelectorAll('[data-product-view]').forEach(function (item) {
      item.classList.toggle('is-active', item === productView);
    });
    var carousel = document.querySelector('[data-product-carousel]');
    if (carousel) {
      carousel.dataset.productPage = '0';
      carousel.dataset.productView = productView.getAttribute('data-product-view') || 'aktuellt';
      updateProductCarousel(carousel);
    }
  }

  var historyBack = event.target.closest('[data-history-back]');
  if (historyBack) {
    var sameSiteReferrer = document.referrer && new URL(document.referrer).origin === window.location.origin;
    if (window.history.length > 1 && sameSiteReferrer) window.history.back();
    else window.location.href = window.Shopify.routes.root;
  }

  var openCatalogSort = event.target.closest('[data-catalog-sort-open]');
  if (openCatalogSort) {
    var sortDialog = document.querySelector('[data-catalog-sort-dialog]');
    if (sortDialog) sortDialog.showModal();
  }
  var closeCatalogSort = event.target.closest('[data-catalog-sort-close]');
  if (closeCatalogSort) closeCatalogSort.closest('dialog').close();

  var typeFilter = event.target.closest('[data-type-filter]');
  if (typeFilter) {
    var filterBar = typeFilter.closest('[data-type-filters]');
    var chosen = typeFilter.getAttribute('data-type-filter');
    filterBar.querySelectorAll('[data-type-filter]').forEach(function (item) {
      item.classList.toggle('is-active', item === typeFilter);
    });
    document.querySelectorAll('[data-product-grid] .grid__item').forEach(function (item) {
      var matches = chosen === '*' || item.getAttribute('data-product-type') === chosen;
      item.classList.toggle('is-hidden', !matches);
    });
  }

  var galleryButton = event.target.closest('[data-gallery-prev], [data-gallery-next]');
  if (galleryButton) {
    var galleryRoot = galleryButton.closest('[data-product-gallery]');
    var thumbs = Array.from(galleryRoot.querySelectorAll('[data-thumb]'));
    var activeIndex = thumbs.findIndex(function (item) { return item.classList.contains('is-active'); });
    var direction = galleryButton.hasAttribute('data-gallery-next') ? 1 : -1;
    var next = (activeIndex + direction + thumbs.length) % thumbs.length;
    thumbs[next].click();
  }

  var openGallery = event.target.closest('[data-open-gallery]');
  if (openGallery) openGallery.closest('[data-product-gallery]').querySelector('[data-gallery-dialog]').showModal();
  var openImage = event.target.closest('[data-open-image]');
  if (openImage) {
    var imageGallery = openImage.closest('[data-product-gallery]');
    var zoomDialog = imageGallery && imageGallery.querySelector('[data-image-zoom-dialog]');
    var zoomTarget = zoomDialog && zoomDialog.querySelector('[data-image-zoom-target]');
    var sourceImage = openImage.matches('img') ? openImage : openImage.querySelector('img');
    if (zoomDialog && zoomTarget) {
      zoomTarget.src = openImage.getAttribute('data-full') || (sourceImage && sourceImage.src) || '';
      zoomTarget.alt = (sourceImage && sourceImage.alt) || '';
      var startIndex = openImage.hasAttribute('data-index') ? Number(openImage.getAttribute('data-index')) : -1;
      if (startIndex < 0) {
        var activeThumb = imageGallery.querySelector('[data-thumb].is-active');
        startIndex = activeThumb ? Number(activeThumb.getAttribute('data-index')) : 0;
      }
      setZoomIndex(zoomDialog, startIndex);
      var parentDialog = openImage.closest('dialog');
      if (parentDialog && parentDialog !== zoomDialog) parentDialog.close();
      zoomDialog.showModal();
    }
  }
  var zoomStep = event.target.closest('[data-zoom-prev], [data-zoom-next]');
  if (zoomStep) {
    var stepDialog = zoomStep.closest('[data-image-zoom-dialog]');
    stepZoom(stepDialog, zoomStep.hasAttribute('data-zoom-next') ? 1 : -1);
  }
  var openShipping = event.target.closest('[data-open-shipping]');
  if (openShipping) document.querySelector('[data-shipping-dialog]').showModal();
  var closeDialog = event.target.closest('[data-dialog-close]');
  if (closeDialog) closeDialog.closest('dialog').close();
  var closeCartAdded = event.target.closest('[data-cart-added-close]');
  if (closeCartAdded) closeCartAdded.closest('dialog').close();

  var minus = event.target.closest('[data-quantity-minus], [data-cart-minus]');
  var plus = event.target.closest('[data-quantity-plus], [data-cart-plus]');
  if (minus || plus) {
    var controls = (minus || plus).parentElement;
    var input = controls.querySelector('input[type="number"]');
    var nextValue = Math.max(Number(input.min || 0), Number(input.value || 0) + (plus ? 1 : -1));
    input.value = nextValue;
    if (input.hasAttribute('data-cart-quantity')) input.closest('form').requestSubmit();
  }
});

function setZoomIndex(dialog, index) {
  var sources = dialog ? dialog.querySelectorAll('[data-zoom-sources] [data-src]') : [];
  if (!sources.length) return;
  var total = sources.length;
  var nextIndex = ((index % total) + total) % total;
  var source = sources[nextIndex];
  var target = dialog.querySelector('[data-image-zoom-target]');
  var counter = dialog.querySelector('[data-zoom-counter]');
  dialog.setAttribute('data-zoom-index', String(nextIndex));
  if (target) {
    target.src = source.getAttribute('data-src');
    target.alt = source.getAttribute('data-alt') || '';
  }
  if (counter) counter.textContent = (nextIndex + 1) + '/' + total;
  [nextIndex + 1, nextIndex - 1].forEach(function (i) {
    var near = sources[((i % total) + total) % total];
    if (near) { var img = new Image(); img.src = near.getAttribute('data-src'); }
  });
  var gallery = dialog.closest('[data-product-gallery]');
  var thumb = gallery && gallery.querySelector('[data-thumb][data-index="' + nextIndex + '"]');
  var main = gallery && gallery.querySelector('#product-main-image');
  var mainCounter = gallery && gallery.querySelector('[data-image-counter]');
  if (thumb && main) {
    main.src = thumb.getAttribute('data-full');
    main.setAttribute('data-full', thumb.getAttribute('data-full'));
    main.removeAttribute('srcset');
    gallery.querySelectorAll('[data-thumb]').forEach(function (item) { item.classList.toggle('is-active', item === thumb); });
    if (mainCounter) mainCounter.textContent = (nextIndex + 1) + '/' + total;
  }
}

function stepZoom(dialog, direction) {
  if (!dialog) return;
  setZoomIndex(dialog, Number(dialog.getAttribute('data-zoom-index') || 0) + direction);
}

(function () {
  var zoomTouchX = null;
  document.addEventListener('touchstart', function (event) {
    zoomTouchX = event.target.closest && event.target.closest('[data-image-zoom-dialog]') ? event.touches[0].clientX : null;
  }, { passive: true });
  document.addEventListener('touchend', function (event) {
    if (zoomTouchX === null) return;
    var dialog = event.target.closest && event.target.closest('[data-image-zoom-dialog]');
    var delta = event.changedTouches[0].clientX - zoomTouchX;
    zoomTouchX = null;
    if (dialog && Math.abs(delta) > 40) stepZoom(dialog, delta < 0 ? 1 : -1);
  }, { passive: true });
})();

document.addEventListener('keydown', function (event) {
  var openZoom = document.querySelector('[data-image-zoom-dialog][open]');
  if (openZoom && (event.key === 'ArrowRight' || event.key === 'ArrowLeft')) {
    event.preventDefault();
    stepZoom(openZoom, event.key === 'ArrowRight' ? 1 : -1);
    return;
  }
  if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('#product-main-image[data-open-image]')) {
    event.preventDefault();
    event.target.click();
  }
});

document.addEventListener('change', function (event) {
  if (event.target.matches('[data-variant-select]')) {
    var option = event.target.options[event.target.selectedIndex];
    var details = event.target.closest('.product__details');
    details.querySelector('.product__current-price').textContent = option.dataset.price;
    details.querySelector('.product__current-price').classList.toggle('is-sale', !!option.dataset.compare);
    var compare = details.querySelector('[data-compare-price]');
    compare.textContent = option.dataset.compare || '';
    compare.classList.toggle('is-hidden', !option.dataset.compare);

  }
  if (event.target.matches('[data-cart-quantity]')) event.target.closest('form').requestSubmit();
  if (event.target.matches('input[name="catalog-sort"]')) {
    var grid = document.querySelector('[data-catalog-grid]');
    if (!grid) return;
    var sortBy = event.target.value;
    var items = Array.from(grid.querySelectorAll('[data-catalog-item]'));
    items.sort(function (a, b) {
      if (sortBy === 'newest') return Number(b.dataset.published || 0) - Number(a.dataset.published || 0);
      if (sortBy === 'price-low') return Number(a.dataset.price || 0) - Number(b.dataset.price || 0);
      if (sortBy === 'price-high') return Number(b.dataset.price || 0) - Number(a.dataset.price || 0);
      if (sortBy === 'pieces-high') return Number(b.dataset.pieces || 0) - Number(a.dataset.pieces || 0);
      return Number(a.dataset.originalOrder || 0) - Number(b.dataset.originalOrder || 0);
    });
    items.forEach(function (item) { grid.appendChild(item); });
  }
});

document.addEventListener('submit', async function (event) {
  var form = event.target.closest('.ajax-product-form');
  if (!form) return;
  event.preventDefault();
  var button = form.querySelector('[type="submit"]');
  button.disabled = true;
  button.classList.add('is-loading');
  try {
    var response = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
    if (!response.ok) throw new Error('Det gick inte att lägga varan i varukorgen.');
    var addedItem = await response.json();
    var cart = await fetch(window.Shopify.routes.root + 'cart.js').then(function (result) { return result.json(); });
    updateCartCount(cart.item_count);
    showCartAddedDialog(addedItem);
  } catch (error) {
    alert(error.message);
  } finally {
    button.disabled = false;
    button.classList.remove('is-loading');
  }
});

var footerQuery = window.matchMedia('(min-width: 750px)');
function setSidfotGroups(event) {
  document.querySelectorAll('[data-footer-group]').forEach(function (group) {
    if (event.matches) group.setAttribute('open', '');
    else group.removeAttribute('open');
  });
}
setSidfotGroups(footerQuery);
footerQuery.addEventListener('change', setSidfotGroups);
(function () {
  var startX = null;
  document.addEventListener('touchstart', function (event) {
    var stage = event.target.closest('[data-product-gallery]');
    startX = stage ? event.touches[0].clientX : null;
  }, { passive: true });
  document.addEventListener('touchend', function (event) {
    if (startX === null) return;
    var gallery = event.target.closest('[data-product-gallery]');
    var delta = event.changedTouches[0].clientX - startX;
    startX = null;
    if (!gallery || Math.abs(delta) < 40) return;
    var selector = delta < 0 ? '[data-gallery-next]' : '[data-gallery-prev]';
    var button = gallery.querySelector(selector);
    if (button) button.click();
  }, { passive: true });
})();


function updateProductCarousel(carousel) {
  var grid = carousel.querySelector('[data-product-grid]');
  if (!grid) return;
  var allItems = Array.from(grid.querySelectorAll('.grid__item'));
  var view = carousel.dataset.productView || 'aktuellt';
  var filter = carousel.dataset.catalogFilter || 'alla';
  var items = allItems.filter(function (item) {
    var type = (item.dataset.productType || '').toLowerCase();
    if (filter === 'exklusivt') return item.dataset.productExclusive === '1';
    if (filter === 'erbjudanden') return item.dataset.productSale === '1';
    if (filter === 'sasong') return item.dataset.productSeason === '1';
    if (filter === 'familj') return item.dataset.productFamily === '1';
    if (filter === 'star-wars') return type.indexOf('star') !== -1;
    if (filter === 'fordon') return type.indexOf('fordon') !== -1;
    return true;
  });
  items.sort(function (a, b) {
    if (view === 'populart') {
      return Number(b.dataset.productSale) - Number(a.dataset.productSale) || b.dataset.productTitle.localeCompare(a.dataset.productTitle, 'sv');
    }
    return Number(a.dataset.productIndex) - Number(b.dataset.productIndex);
  });
  var currentOrder = Array.from(grid.querySelectorAll('.grid__item'));
  var orderChanged = items.some(function (item, index) { return currentOrder[index] !== item; });
  if (orderChanged) {
    items.forEach(function (item) { grid.appendChild(item); });
    allItems.forEach(function (item) {
      if (items.indexOf(item) === -1) grid.appendChild(item);
    });
  }
  allItems.forEach(function (item) { item.classList.toggle('is-filtered-out', items.indexOf(item) === -1); });
  var pageCount = Math.max(1, Math.ceil(items.length / 5));
  var requestedPage = Number(carousel.dataset.productPage || 0);
  var page = Math.max(0, Math.min(Number.isFinite(requestedPage) ? requestedPage : 0, pageCount - 1));
  carousel.dataset.productPageCount = String(pageCount);
  carousel.dataset.productPage = String(page);
  grid.style.setProperty('--carousel-page', String(page));
  var prev = carousel.querySelector('[data-product-prev]');
  var next = carousel.querySelector('[data-product-next]');
  if (prev) prev.disabled = page === 0;
  if (next) next.disabled = page >= pageCount - 1;
}

function initializeProductCarousels() {
  document.querySelectorAll('[data-product-carousel]').forEach(function (carousel) {
    carousel.dataset.productPage = '0';
    updateProductCarousel(carousel);
    carousel.querySelectorAll('[data-product-prev], [data-product-next]').forEach(function (arrow) {
      if (arrow.dataset.carouselReady === '1') return;
      arrow.dataset.carouselReady = '1';
      arrow.addEventListener('click', function () {
        var page = Number(carousel.dataset.productPage || 0);
        var pageCount = Number(carousel.dataset.productPageCount || 1);
        var direction = arrow.hasAttribute('data-product-next') ? 1 : -1;
        carousel.dataset.productPage = String(Math.max(0, Math.min(pageCount - 1, page + direction)));
        updateProductCarousel(carousel);
      });
    });
  });
}

initializeProductCarousels();
document.addEventListener('shopify:section:load', initializeProductCarousels);

function initializeProductRecommendations() {
  document.querySelectorAll('[data-product-recommendations]').forEach(function (section) {
    if (section.dataset.recommendationsReady === '1') return;
    var rail = section.querySelector('.product-recommendations__rail');
    if (!rail) return;
    var items = Array.from(rail.querySelectorAll('[data-recommendation-item]'));
    for (var index = items.length - 1; index > 0; index -= 1) {
      var randomIndex = Math.floor(Math.random() * (index + 1));
      var temporary = items[index];
      items[index] = items[randomIndex];
      items[randomIndex] = temporary;
    }
    items.forEach(function (item, index) {
      if (index < 15) {
        item.hidden = false;
        rail.appendChild(item);
      } else {
        item.remove();
      }
    });
    var prev = section.querySelector('[data-recommendations-prev]');
    var next = section.querySelector('[data-recommendations-next]');
    function updateArrows() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -rail.clientWidth, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: rail.clientWidth, behavior: 'smooth' }); });
    rail.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
    section.dataset.recommendationsReady = '1';
  });
}

initializeProductRecommendations();
document.addEventListener('shopify:section:load', initializeProductRecommendations);

/* ---------- Sök i butiken ---------- */
(function () {
  var modal = document.querySelector('[data-search-modal]');
  if (!modal) return;
  var input = modal.querySelector('[data-search-input]');
  var results = modal.querySelector('[data-search-results]');
  var label = modal.querySelector('[data-search-label]');
  var products = [];
  var loaded = false;

  function money(amount) {
    var value = parseFloat(amount || '0');
    var decimals = value % 1 === 0 ? 0 : 2;
    return value.toLocaleString('sv-SE', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }) + ' kr';
  }

  function load() {
    if (loaded) return Promise.resolve(products);
    return fetch('/products.json?limit=250', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        products = (data.products || []).map(function (product) {
          var variant = (product.variants || [])[0] || {};
          var image = (product.images || [])[0];
          return {
            title: product.title,
            url: '/products/' + product.handle,
            image: image ? image.src : '',
            type: product.product_type || 'Byggset',
            tags: (product.tags || []).join(' '),
            sku: variant.sku || '',
            price: money(variant.price),
            compare: variant.compare_at_price && parseFloat(variant.compare_at_price) > parseFloat(variant.price) ? money(variant.compare_at_price) : null
          };
        });
        loaded = true;
        return products;
      })
      .catch(function () { return []; });
  }

  function shuffle(list) {
    var next = list.slice();
    for (var i = next.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = next[i]; next[i] = next[j]; next[j] = tmp;
    }
    return next;
  }

  function row(product) {
    var compare = product.compare ? '<span class="search-row__old">' + product.compare + '</span>' : '';
    var image = product.image ? '<img src="' + product.image + '" alt="" loading="lazy">' : '';
    return '<a class="search-row" href="' + product.url + '">' +
      '<span class="search-row__media">' + image + '</span>' +
      '<span class="search-row__body"><span class="search-row__type">' + product.type + '</span>' +
      '<span class="search-row__title">' + product.title + '</span></span>' +
      '<span class="search-row__prices"><span class="search-row__price' + (product.compare ? ' is-sale' : '') + '">' + product.price + '</span>' + compare + '</span></a>';

  }

  function render(list, isSuggestion, term) {
    label.textContent = isSuggestion ? 'Populära förslag' : 'Sökresultat';
    if (!list.length) {
      results.innerHTML = isSuggestion
        ? '<p class="search-modal__empty">Laddar produkter …</p>'
        : '<p class="search-modal__empty">Inga produkter hittades för "' + term + '".</p>';
      return;
    }
    results.innerHTML = list.map(row).join('');
  }

  function showSuggestions() {
    render(shuffle(products).slice(0, 4), true);
  }

  function search(term) {
    var words = term.toLowerCase().split(/\s+/).filter(Boolean);
    return products.filter(function (product) {
      var haystack = [product.title, product.type, product.tags, product.sku].join(' ').toLowerCase();
      return words.every(function (word) { return haystack.indexOf(word) !== -1; });
    }).slice(0, 12);
  }

  function open() {
    modal.hidden = false;
    document.body.classList.add('has-search-open');
    input.value = '';
    showSuggestions();
    load().then(function () {
      if (!modal.hidden && input.value.trim().length < 2) showSuggestions();
    });
    setTimeout(function () { input.focus(); }, 50);
  }

  function close() {
    modal.hidden = true;
    document.body.classList.remove('has-search-open');
  }

  document.querySelectorAll('[data-search-open]').forEach(function (button) {
    button.addEventListener('click', open);
  });
  modal.querySelectorAll('[data-search-close]').forEach(function (button) {
    button.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.hidden) close();
  });
  input.addEventListener('input', function () {
    var term = input.value.trim();
    if (term.length < 2) { showSuggestions(); return; }
    render(search(term), false, term);
  });
})();
// Förladda alla produktbilder i bakgrunden så bläddrandet mellan bilderna går direkt.
(function () {
  document.querySelectorAll('[data-product-gallery] [data-thumb], [data-product-gallery] [data-open-image][data-full]').forEach(function (el) {
    var src = el.getAttribute('data-full');
    if (!src) return;
    var img = new Image();
    img.decoding = 'async';
    img.src = src;
  });
})();
